import script from "./ReportsStatCards.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReportsStatCards.vue?vue&type=script&setup=true&lang=ts"

import "./ReportsStatCards.vue?vue&type=style&index=0&id=580cbfb0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-580cbfb0"]])

export default __exports__